var _ = require('underscore');
module.exports = {
  intersectSets: intersectSets,
  intersectSort: intersectSort
};

// Get the intersection of sets.
//
// sets - Array of Arrays to intersect.
//
// Examples
//
//    intersection = intersectSets([[1,2,3], [1,2], [1]])
//    // => [1]
//
// Returns an Array containing the elements present in all sets.
function intersectSets(sets) {
  // http://readystate4.com/2008/08/17/javascript-argument-unpacking-converting-an-array-into-a-list-of-arguments/
  // .apply is Javascript's splat (*) operator
  return _.intersection.apply(this, sets);
}

// Intersect two sets, but return an ordered array of
// the intersection.
//
// sort - Array used to order the results.
// set  - Array of elements you'd like in the output.
//
// Examples
//
//    sorted = intersectSort([1,2,3,4], [5,3,2])
//    // => [2,3]
//
// Returns an Array.
function intersectSort(sort, set) {
  return _.intersection(sort, set);
}
